import { AddCircle, Block, Clear, Download, Edit, EditAttributesRounded, HandymanOutlined, Image, PictureAsPdf, RadioButtonUnchecked, Rotate90DegreesCw, Search, TaskAlt } from "@mui/icons-material";
import { Tabs, Tab, Box, ListItem, ListItemButton, List, ListItemText, Dialog, DialogTitle, DialogContent, Paper, TextField, FormControl, InputLabel, Select, MenuItem, Typography, Divider, DialogActions, Button, ToggleButtonGroup, ToggleButton, InputAdornment, Snackbar, Autocomplete, ListItemSecondaryAction, Chip } from "@mui/material";
import { DataTable } from "./datatable";
import { Edituser } from "./edituser";
import { format } from "date-fns";
import { Container } from "@mui/system";
import { useState, useEffect } from "react";
import {useGlobal} from 'reactn';
import { MessageCenter } from "./messagecenter";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import '@sweetalert2/theme-material-ui/material-ui.css';
import { Bereichsauswahl } from "./utils";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import './manage.css'
import { useParams } from "react-router";
import { UserAccordionReports } from "./reports";
import { TransformComponent, TransformWrapper } from "react-zoom-pan-pinch";





export function Bescheinigungen({userid,changeview}) {
    const [axios] = useGlobal('axios')
    const [toggletasks,setToggletasks] = useGlobal('tasks')
    const [userliste,setUserliste] = useState([])
    const [viewuser,setViewuser] = useState(null)
    const [status,setStatus] = useState(false)
    const [cmeliste,setCmeliste] = useState([])
    const [cmebyuser,setCmebyuser] = useState([])
    const [cmeoffen,setCmeoffen] = useState([])
    const [filter,setFilter] = useState('')
    const [revisit,setRevisit] = useState(false)
    const [showcme,setShowcme] = useState(false)
    const [snackbarmessage,setSnackbarmessage] = useState(false)
    const [tabvalue,setTabvalue] = useState(0)
    const [edituser,setEdituser] = useState(false)
    const { urlparameter } = useParams()
    const statuslist = ['pending','granted','rejected']

    useEffect(() => {
       getcmelist()
    },[])



    useEffect(() => {
        console.log(urlparameter)
        if (userid) {
            axios.get('userdata',{ params: { user: userid} }).then(u => setViewuser(u.data))
        } else {
            setViewuser(null)
        }
    },[userid])

    useEffect(() => {
        console.log(viewuser)
        if (viewuser) {
            //axios.get('bescheinigungen',{ params: { user: viewuser._id } }).then(data => setCmeliste(data.data))
            axios.get('checkbeschstatus',{ params: { withreports: true, userid:viewuser._id }}).then(data => setStatus(data.data))
        } else {
            axios.get('allbescheinigungen').then(data => {setCmeliste(data.data)})
            setStatus(false)
        }
    },[viewuser])

     const getcmelist = () => {
        axios.get('allbescheinigungen').then(data => {
            setCmeliste(data.data)
        })
        axios.get('get_userliste').then(data => {
            console.log('userliste',data)
            setUserliste(data.data)
        })
        axios.get('getcmebyuser').then(data => {
            setCmebyuser(data.data)
        })
        axios.get('getcmebyuser',{ params: { offen: 1 } }).then(data => {
            setCmeoffen(data.data)
        })
    }

    const closeCMEEditDialog = () => {
        setRevisit(false)
        getcmelist()
    }

    // Zeilenklick in »nach Notarzt« / »Nachweis offen«: Benutzerdialog direkt im Tab »Fortbildung« öffnen
    const openUserDetail = (na) => {
        const u = userliste.find(x => x._id === na.userid)
        if (u) setEdituser(u)
    }
    const closeUserDetail = () => {
        setEdituser(false)
        getcmelist()   // Befreiung könnte sich geändert haben
    }

    // const downloadBescheinigung = (e,cme) => {
    //     console.log('dl',e)
    //     let link = document.createElement('a')
    //     link.href = 'https://notarzt-heinsberg.de/api/bescheinigung/'+cme;
    //     link.target = '_blank';
    //     document.body.appendChild(link);
    //     link.click();
    // }


    const handleCMEDialogclose = (result) => {
        if (result.reload) {
            getcmelist()
        }
        if (result.message) {
            setSnackbarmessage(result.message)
        }
        setShowcme(false)
    }


    const statuslabel = { pending: 'In Bearbeitung', granted: 'akzeptiert', rejected: 'abgelehnt' }
    const statuscolor = { pending: 'error', granted: 'success', rejected: 'default' }
    const formatDatum = (d) => { try { return format(new Date(d), 'd.M.y') } catch { return d } }

    // Spalten »nach Bescheinigung«: Sortierung nach Status folgt der Reihenfolge in statuslist
    const cmeColumns = [
        { id: 'username', label: 'Notarzt', get: c => c.username, render: c => <b>{c.username}</b> },
        { id: 'datum', label: 'Datum', get: c => c.datum, render: c => formatDatum(c.datum) },
        { id: 'punkte', label: 'Punkte', get: c => Number(c.punkte), align: 'right' },
        { id: 'status', label: 'Status', get: c => statuslist.indexOf(c.status),
          render: c => <Chip size='small' label={statuslabel[c.status] || c.status} color={statuscolor[c.status] || 'default'} variant={c.status === 'pending' ? 'filled' : 'outlined'}/> },
        { id: 'datei', label: 'Datei', sortable: false, align: 'center', hideBelow: 'sm', get: c => c.mimetype,
          render: c => c.mimetype === 'application/pdf' ? <PictureAsPdf fontSize='small' color='action'/> : <Image fontSize='small' color='action'/> },
    ]
    // Innerhalb eines Status neueste zuerst – der stabile Sort der Tabelle behält diese Reihenfolge bei
    const cmelisteSorted = [...cmeliste].sort((a,b) => String(b.datum).localeCompare(String(a.datum)))

    // Spalten »nach Notarzt« / »Nachweis offen«: Vorzeitraum und aktueller Zeitraum getrennt, sortierbar nach Punkten
    const zeitraum = (na, akt) => (na.cme || []).find(zr => !!zr.akt === akt)
    const zeitraumCell = (zr) => zr ? <div className='datatable-zeitraum'>{zr.zeitraum}<br/><b>{zr.punkte ?? 0}</b> Punkte</div> : null
    const userColumns = [
        { id: 'user', label: 'Notarzt', get: na => na.user, render: na => <b>{na.user}</b> },
        { id: 'groups', label: 'Bereiche', get: na => na.groups, hideBelow: 'sm' },
        { id: 'pre', label: 'Vorzeitraum', get: na => Number(zeitraum(na,false)?.punkte ?? 0), render: na => zeitraumCell(zeitraum(na,false)) },
        { id: 'akt', label: 'Aktuell', get: na => Number(zeitraum(na,true)?.punkte ?? 0), render: na => zeitraumCell(zeitraum(na,true)) },
    ]
    const fehlendColumn = { id: 'fehlend', label: 'fehlend', get: na => Number(na.fehlend), align: 'right', render: na => <b style={{color:'#C8102E'}}>{na.fehlend}</b> }

    const download_excel_list = (nuroffene) => {
        let fitlerstring = filter || '__'
        let link = document.createElement('a')
        link.href = 'https://notarzt-heinsberg.de/api/getcmelist/'+encodeURIComponent(fitlerstring)+(nuroffene ? '?offen=1' : '');
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
    }


    return (
        <Container maxWidth='md' className='ulistcontainer'>
        <Tabs centered value={tabvalue} onChange={(e,v) => setTabvalue(v)}>
            <Tab label='nach Bescheinigung'/>
            <Tab label='nach Notarzt'/>
            <Tab label={'Nachweis offen'+(cmeoffen.length ? ' ('+cmeoffen.length+')' : '')}/>
        </Tabs>

            {/* <TextField label='Filter' type='search' fullWidth value={filter} onChange={e => setFilter(e.target.value.toLowerCase())} size="small" InputProps={{endAdornment: <InputAdornment position="end"><Search/></InputAdornment>,}}/> */}
        {tabvalue == 0 && <>
            <Autocomplete options={userliste} getOptionLabel={(o) => o.name?.vorname+' '+o.name?.nachname} filterSelectedOptions
                    onChange={(event, newValue) => {setViewuser(newValue);}} autoSelect autoHighlight
                    value={viewuser}
                    renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="filled"
                          label="Notarzt"
                        />
                      )}
                
                />
            {!viewuser &&
            <DataTable columns={cmeColumns} rows={cmelisteSorted} rowKey={c => c._id}
                defaultSort='status'
                searchLabel='Notarzt'
                searchFields={[c => c.username]}
                filters={{ options: [{value:'alle',label:'Alle'}, ...statuslist.map(s => ({value:s, label:statuslabel[s]}))],
                           match: (c,v) => v === 'alle' || c.status === v }}
                rowClass={c => c.status}
                onRowClick={c => setShowcme(c)}
                emptyText='Keine Bescheinigungen gefunden'/>
            }
            {viewuser && 
            <UserAccordionReports status={status} docmestuff={e =>  setShowcme(e)}/>
            }
        </>
        }
        {tabvalue >= 1 && <>
            {tabvalue == 2 && <Typography variant="body2" sx={{mt:1}}>
                Notärzte, deren abgeschlossener Vorzeitraum weniger als 20 Punkte aufweist (Befreiungen berücksichtigt).
            </Typography>}
            <DataTable key={'byuser'+tabvalue} columns={tabvalue == 2 ? [...userColumns, fehlendColumn] : userColumns}
                rows={tabvalue == 2 ? cmeoffen : cmebyuser} rowKey={na => na.userid || na.user}
                defaultSort={tabvalue == 2 ? 'fehlend' : 'user'} defaultDir={tabvalue == 2 ? 'desc' : 'asc'}
                searchLabel='Notarzt oder Bereich'
                searchFields={[na => na.user, na => na.groups]}
                search={filter} onSearch={setFilter}
                toolbar={<Button variant="outlined" size='small' startIcon={<Download/>} onClick={e => download_excel_list(tabvalue == 2)}>Excel</Button>}
                onRowClick={na => openUserDetail(na)}
                emptyText='Keine Notärzte gefunden'/>
        </>
        }
        <Edituser user={edituser} initialTab={1} close={e => closeUserDetail()} onMessage={changeview ? (u => changeview(u._id,0)) : undefined}/>
        <ModCMEDialog cme={showcme} close={m => handleCMEDialogclose(m)}/>
        <Snackbar open={!!snackbarmessage} message={snackbarmessage} autoHideDuration={5000} onClose={e => setSnackbarmessage(false)}/>
        </Container>
    )
}


function ModCMEDialog({cme,close}) {
    const [axios] = useGlobal('axios')
    const [modcme,setModcme] = useState({})
    const [duplicate,setDuplicate] = useState(false)
    const [rot,setRot] = useState(0)

    useEffect(() => {
            console.log('modcmeDialog',cme)
            setModcme(cme)
            setRot(0)
            setDuplicate(false)
    },[cme])


    const delcme = () => {
        axios.post('deleteBescheinigung',{...modcme,id:modcme._id}).then(res => 
            close({'reload':true,'message':'Bescheinigung gelöscht'})
        )
    }

    const savecme = () => {
        axios.post('statuschange',{...modcme,duplicate:duplicate,status:'granted'}).then(res =>
        close({'reload':true,'message':'Bescheinigung freigegeben'})
        )
    }

    const updatecme = () => {
        axios.post('updatecme',{...modcme,duplicate:duplicate}).then(res =>             
            close({'reload':true,'message':'Bescheinigung geändert'})
            )
    }

    const resetcme = () => {
        axios.post('statuschange',{...modcme,status:'pending'}).then(res =>             
            close({'reload':true,'message':'Bescheinigung zurückgesetzt'})
            )        
    }

   


    return(
        <Dialog open={!!modcme} fullWidth maxWidth='md'>
            <DialogTitle>Bescheinigung bearbeiten</DialogTitle>

            <DialogContent>
            <div style={{height:'60vh'}}>   
            {/* Hier split nach Mimetype              */}
            {modcme && modcme?._id && 
            <>
                {modcme.mimetype === 'application/pdf' ?
                    <iframe src={'https://notarzt-heinsberg.de/api/bescheinigung/'+cme._id+'#view=fitH'} title="testPdf" height="100%" width="100%" />
                    :
                    <TransformWrapper centerOnInit style={{height:'inherit'}} wrapperClass='transformwrapper'>
                        <TransformComponent>
                                <img src={'https://notarzt-heinsberg.de/api/bescheinigung/'+modcme._id} alt="test" />
                        </TransformComponent>
                    </TransformWrapper>                 
                }
            </>            
            }
            </div>
            <div style={{marginTop:'8px'}}>Letzter Bescheinigungszeitraumwechsel von {modcme?.username} am <b>{modcme?.lastblockend}</b></div>
            <div style={{marginTop:'8px'}}><i>Zum Aufteilen der Bescheinigung (+) klicken und Datum vor/nach des Zeitraumwechsels mit entsprechender Punktzahl wählen.</i></div>
            <div className="cmedialogding">
                <TextField  size='small' style={{flexGrow:'1'}} label='Datum' type='date' InputLabelProps={{ shrink: true }} value={modcme?.datum} onChange={e => setModcme({...modcme,datum:e.target.value})}/>
                <TextField size='small' style={{flexGrow:'1'}} label='Punkte' type='number' InputLabelProps={{ shrink: true }} value={modcme?.punkte} onChange={e => setModcme({...modcme,punkte:e.target.value})}/>
                {!duplicate && <AddCircle onClick={e => setDuplicate({'datum':modcme?.datum,'punkte':0})}/>}
            </div>
            {duplicate && 
                    <div className="cmedialogding">
                    <TextField  size='small' style={{flexGrow:'1'}} label='Datum' type='date' InputLabelProps={{ shrink: true }} value={duplicate?.datum} onChange={e => setDuplicate({...duplicate,datum:e.target.value})}/>
                    <TextField size='small' style={{flexGrow:'1'}} label='Punkte' type='number' InputLabelProps={{ shrink: true }} value={duplicate?.punkte} onChange={e => setDuplicate({...duplicate,punkte:e.target.value})}/>
                </div>                        
            }
            </DialogContent>

            <DialogActions>
                <Button variant='outlined' onClick={e => close({reload:false,message:false})}>abbrechen</Button>
                <Button variant='outlined' onClick={e => delcme()}>löschen</Button>
                <Button variant='contained' onClick={e => updatecme()}>speichern</Button>
                <Button variant='contained' onClick={e => {modcme.status === 'granted' ?  resetcme() : savecme()}}>
                    {modcme.status === 'pending' ? 'akzeptieren' : 'auf "In Bearbeitung" zurücksetzen'}
                </Button>
            </DialogActions>
        </Dialog>
    )
}



